<template>
  <div class="failed-login">
    <img src="../assets/failed-login.svg" :alt="$t('Failed Login Image')">
    <p>{{ $t('SpringboardVR may be experiencing some issues. Check out our') }} <a href="https://status.springboardvr.com" rel="noopener">{{ $t('status page') }}</a></p>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component()
export default class FailedLogin extends Vue {}
</script>

<style lang="postcss" scoped>
@import '../styles';

.failed-login {
  @apply --contentContainer;

  text-align: center;
  padding-top: var(--spacingLg);

  & img {
    width: 40rem;
    margin: 15vh auto var(--spacingMd) auto;
  }

  & p {
    @apply --f5;
  }

  & a {
    @apply --f5;

    color: var(--colorSBRedFlat);
    text-decoration: underline;
  }
}
</style>
